import React from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import { closeButton } from '../Modals/ModalButtons';
import Icons from '../Common/Icons';
import HelpView from './HelpView';

import styles from './HelpModal.module.css';
import PropTypes from 'prop-types';

const HelpModal = ({ isOpen, onClose, file }) => {
  const T = useTranslation();

  return (
    <div style={{ zIndex: 500 }}>
      <Modal
        variant={ModalVariant.large}
        title={T.dashboard.editor.inputs.help.title}
        titleIconVariant={() => <Icons.Help />}
        isOpen={isOpen}
        onClose={onClose}
        actions={closeButton({ T, onClose })}
        className={styles.modalhelp}
      >
        <HelpView file={file} className={styles.content}/>
      </Modal>
    </div>
  );
};

HelpModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  file: PropTypes.string.isRequired
};

export default React.memo(HelpModal);
